import { render, staticRenderFns } from "./BankEditor.vue?vue&type=template&id=dbe31312&scoped=true"
import script from "./BankEditor.vue?vue&type=script&lang=js"
export * from "./BankEditor.vue?vue&type=script&lang=js"
import style0 from "./BankEditor.vue?vue&type=style&index=0&id=dbe31312&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe31312",
  null
  
)

export default component.exports